import './css/Game.css'

const Game = (props) => {
    return(
    <div className='game-page'>
        <img src='https://cdn-icons-png.flaticon.com/128/2228/2228426.png'/>
        <span>Game</span>
    </div>)
}

export default Game;